export interface Auth0InitResponse {
  cache: Auth0StorageResponse;
  cacheLocation: 'memory' | 'localstorage';
  cookieStorage: Auth0StorageResponse;
  customOptions: Auth0ClientOptions;
  defaultScope: string;
  domainUrl: string;
  options: Auth0ClientOptions;
  scope: string;
  sessionCheckExpiryDays: Number;
  tokenIssuer: string;
  transactionManager: Auth0TransactionManagerResponse;
  worker: Auth0WorkerResponse;
}

export interface Auth0ClaimsResponse {
  aud: string;
  email: string;
  email_verified: boolean;
  exp: number;
  iat: number;
  iss: string;
  name: string;
  nickname: string;
  nonce: string;
  picture: string;
  sub?: string;
  updated_at: string;
  __raw?: string;
  uuid?: string;
  accessToken?: string;
}

export interface Auth0StorageResponse {
  get: Function;
  save: Function;
  remove?: Function;
  clear?: Function;
}

export interface Auth0ClientOptions {
  client_id: string;
  domain: string;
  redirect_uri?: string;
  acr_values?: string;
  appState?: any;
  audience?: string;
  connection?: string;
  display?: 'page' | 'popup' | 'touch' | 'wap';
  fragment?: string;
  id_token_hint?: string;
  login_hint?: string;
  max_age?: string | number;
  prompt?: 'none' | 'login' | 'consent' | 'select_account';
  scope?: string;
  ui_locales?: string;
}

export interface Auth0TransactionManagerResponse {
  storage: Auth0StorageResponse;
  transaction: any;
}

export interface Auth0WorkerResponse {
  onMessage: Function;
  onError: Function;
}

export interface Auth0RedirectCallbackResponse {
  appState?: any;
}

export interface Auth0LoginErrorResponse {
  error: string;
  error_description: string;
  code?: string;
  state?: string;
}
export function isAuth0InitResponse(object: any): object is Auth0InitResponse {
  return (<Auth0InitResponse>object).cache !== undefined;
}

export interface Auth0ClientOptionsInit extends Auth0ClientOptions {
  client_id: string;
  domain: string;
}
